import { LinearSRGBColorSpace, PMREMGenerator, TextureLoader } from 'three';
import { EXRLoader } from 'three/addons';
import { ref, shallowRef } from 'vue';

import { requestIdleCallback } from '@resn/gozer-misc';

const envMaps = new Map();
const envMap = shallowRef(null);

export const useEnvMapLoader = () => {
    const loadEnvMap = async (renderer, src) => {
        // Check if we've already loaded this environment map
        if (envMaps.has(src)) {
            const cached = envMaps.get(src);
            // If already loaded, return immediately
            if (cached.map.value !== null) {
                return cached;
            }
            // If still loading, wait for it
            return cached.promise;
        }

        const envMapObject = { src, map: shallowRef(null), promise: null };

        const loaderType = src.includes('.exr') ? EXRLoader : TextureLoader;
        const loader = new loaderType();
        const pmremGenerator = new PMREMGenerator(renderer);

        envMapObject.promise = new Promise((resolve) => {
            loader.load(src, (result) => {
                result.colorSpace = LinearSRGBColorSpace;
                const tex = pmremGenerator.fromEquirectangular(result).texture;

                // Clean up resources
                result.dispose();
                pmremGenerator.dispose();

                // Cache for reuse
                envMapObject.map.value = tex;
                envMap.value = tex;

                requestIdleCallback(() => {
                    renderer.initTexture(tex);
                });

                resolve(envMapObject);
            });
        });

        envMaps.set(src, envMapObject);
        return envMapObject.promise;
    };

    const dispose = () => {
        envMaps.forEach((obj) => obj.map.value?.dispose());
        envMaps.clear();
    };

    return { loadEnvMap, dispose, envMap };
};
